var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDel(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.245,
    height: 20.758,
    viewBox: "0 0 18.245 20.758",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_8307",
    "data-name": "\\uADF8\\uB8F9 8307",
    transform: "translate(0.125 0.125)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_8308",
    "data-name": "\\uADF8\\uB8F9 8308",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_36937",
    "data-name": "\\uD328\\uC2A4 36937",
    d: "M27.194,33.8a.367.367,0,0,0,.362-.362V29.24a.361.361,0,1,0-.722,0v4.194a.362.362,0,0,0,.361.362",
    transform: "translate(-16.03 -17.253)",
    fill: "#222",
    stroke: "#222",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_36938",
    "data-name": "\\uD328\\uC2A4 36938",
    d: "M16.426,33.794a.362.362,0,0,0,.362-.361V29.238a.361.361,0,1,0-.722,0v4.195a.361.361,0,0,0,.361.361",
    transform: "translate(-9.597 -17.252)",
    fill: "#222",
    stroke: "#222",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_36939",
    "data-name": "\\uD328\\uC2A4 36939",
    d: "M17.634,4.38H13.812l-.056-.337a4.825,4.825,0,0,0-9.521,0L4.18,4.38H.361a.361.361,0,0,0,0,.723H1.394V18.238a2.278,2.278,0,0,0,2.27,2.27H14.328A2.278,2.278,0,0,0,16.6,18.238V5.1h1.036a.361.361,0,0,0,0-.723M15.876,18.239a1.552,1.552,0,0,1-1.547,1.548H3.664a1.553,1.553,0,0,1-1.548-1.547V5.1h13.76ZM5,3.885a4.1,4.1,0,0,1,7.988,0l.118.5H4.884Z",
    transform: "translate(0 0)",
    fill: "#222",
    stroke: "#222",
    strokeWidth: 0.25
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDel);
export default __webpack_public_path__ + "static/media/del.78d71f4ae5c350b56fdeac31c2e9f25e.svg";
export { ForwardRef as ReactComponent };